jQuery(document).ready(function ($) {
	// Addons active state
	$('.addon input').on('click', function () {
		$(this).closest('label').toggleClass('active');
	});
});
